import { Component, OnInit, Output, OnDestroy } from '@angular/core';
import { ToolDescriptionByTypeService, ToolService, ToolTypeService, ToolNumberService } from '../../../camtl.service';

import { Tool } from '../../../../../shared/model';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { SystemSelectService } from '../../../system-select/system-select.service';
import { ToolHandednessService } from '../../../../mesc/mesc.service';
import { MasterToolListBase } from '../../master-tool-list-base.component';
import { Subscription } from 'rxjs/Subscription';
import { RouteValidationService } from "../../../../../shared/route-validation.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-weldgun-design',
  templateUrl: './weldgun-design.component.html',
  // styleUrls: ['./weldgun-design.component.scss']
})
export class WeldgunDesignComponent extends MasterToolListBase implements OnInit, OnDestroy {

  constructor(
    toolTypeService: ToolTypeService,
    public service: ToolService,
    public toolDescriptionService: ToolDescriptionByTypeService,
    private toolNumberService: ToolNumberService,
    private systemSelectService: SystemSelectService,
    private formBuilder: FormBuilder,
    private toolHandednessService: ToolHandednessService,
    public routeValidationService: RouteValidationService) {
    super(service, "WeldGun", toolDescriptionService);
    var self = this;
  }

  editForm: FormGroup;
  isNew: boolean = false;
  editDataItem: Tool;


  private ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  columns: any[] = [{
    field: 'ToolDetail.ToolNumber',
    title: 'Tool Number',
    width: 175
  },
  {
    field: 'ToolDescriptionId',
    title: 'Description',
    template: {
      type: 'filter',
      pipe: 'nameById',
      dataSource: this.toolDescriptionService
    }
  },
  {
    field: 'AdditionalInfo',
    title: 'Additional Info'
  },
  {
    field: 'ToolHandednessId',
    title: 'Design Handedness',
    template: {
      type: 'filter',
      pipe: 'nameById',
      dataSource: this.toolHandednessService
    }
  },
  {
    field: 'LeftCount',
    title: 'LH',
    width: 70
  },
  {
    field: 'RightCount',
    title: 'RH',
    width: 70
  },
  {
    field: 'SingleCount',
    title: 'S',
    width: 70
  }];

  onRead = (): Promise<any> => {
    var self = this;
    if (this.system && this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Configuration/WeldgunDesign')) {
      this.toolHandednessService.query();
      return this.toolTypeService.read()
        .then(function (response: any) {
          self.weldGunId = response.filter(function (item) {
            return item.Description === "WeldGun";
          })[0].Id;

          return self.toolDescriptionService.read("/" + self.weldGunId + "/toolDescription", true).then(function () {
            return self.service.read('/' + self.system.Id + "/toolType/" + self.weldGunId, true);
          });
        })
    }
  }


  handleDelete = (dataItem): Promise<any> => {
    return this.service.remove('/' + dataItem.Id);
  }



  template = {
    controls: {
      add: true,
      edit: true,
      delete: true,
      excel: true
    },
    read: this.onRead,
    delete: this.handleDelete,
    columns: this.columns,
    service: this.service,
    fileName: 'weldgun_design_tools.xlsx'
  };

  ngOnInit() {
    var self = this;

    this.editForm = this.formBuilder.group({
      Id: [],
      ToolNumber: [{ value: [] }],
      ToolDescriptionId: [{ value: [] }, Validators.required],
      AdditionalInfo: [""],
      ToolHandednessId: ["", Validators.required],
      DesignHandedness: [{ value: [] }],
      LeftCount: [""],
      RightCount: [""],
      SingleCount: [""],
      CreatedBy: [],
      CreatedDate: [],
      SystemId: [""],
      MakeFurnish: [""],
      ToolTypeId: []
    })

    this.systemSelectService.system$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(system => {
        this.system = system;
      });

    this.systemSelectService.get();
  }

  formDialog = {
    title: "Weldgun Design",
    formControls: [
      {
        type: 'combobox',
        name: "ToolDescriptionId",
        title: "Tool Description",
        placeholder: 'Select Tool Description',
        textField: "Name",
        valueField: "Id",
        service: this.toolDescriptionService
      },
      {
        type: 'text',
        name: 'AdditionalInfo',
        title: 'Additional Info'
      },
      {
        type: 'combobox',
        name: 'ToolHandednessId',
        title: 'Design Handedness',
        textField: 'Name',
        valueField: 'Id',
        placeholder: 'Select Design Handedness...',
        service: this.toolHandednessService
      },
      {
        type: 'number',
        name: 'LeftCount',
        title: 'LH',
        minimum: 0,
        step: 1
      },
      {
        type: 'number',
        name: 'RightCount',
        title: 'RH',
        minimum: 0,
        step: 1
      },
      {
        type: 'number',
        name: 'SingleCount',
        title: 'S',
        minimum: 0,
        step: 1
      }
    ]
  }

  setModelHandler() {
    this.editDataItem = new Tool();
    this.editDataItem.ToolTypeId = this.weldGunId;
    this.editDataItem.MakeFurnish = "M";

    if (this.system) {
      this.editDataItem.SystemId = this.system.Id;
    }
  }

}
